import { Box, styled } from "@mui/material";

import { CreateProfileFormType } from "../../services/user-create/user-create.schema";
import GvInputController from "../Controllers/GvInputController/GvInputController";
import GvPrimaryButton from "../GvPrimaryButton/GvPrimaryButton";
import { PersonalDetailsFormPartOneSchema } from "../../services/user-create-v2/user-create.schema";
import React from "react";
import { getPhonePattern } from "../../utils";
import { useForm } from "react-hook-form";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";
import { yupResolver } from "@hookform/resolvers/yup";

interface IAddPersonalDetailsForm {
  onSubmitStep1: (data: any) => void;
  personalDetails: any;
}

export const FlexStyleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const AddPersonalDetailsForm: React.FC<IAddPersonalDetailsForm> = ({ onSubmitStep1, personalDetails }) => {
  const { user } = useUserStore();
  const isPhoneAlreadyEnabled = user?.fireBasePhone ? true : false;

  const { control, handleSubmit } = useForm<CreateProfileFormType>({
    mode: "onChange",
    resolver: yupResolver(PersonalDetailsFormPartOneSchema),
    defaultValues: {
      firstName: personalDetails ? personalDetails.firstName : "",
      lastName: personalDetails ? personalDetails.lastName : "",
      phone: user?.fireBasePhone ? getPhonePattern(user?.fireBasePhone) : personalDetails ?
        personalDetails.phone : "",
      email: user ? user.email : "",
      setphoneforlogin: isPhoneAlreadyEnabled || false,
      otp: null,
      channelFoundUs: personalDetails ? personalDetails.channelFoundUs : undefined,
      location: null,
      contactId: null,
      placeId: null,
      address: "",
      streetAddress: personalDetails ? personalDetails.streetAddress : "",
      country: "",
      townCity: personalDetails ? personalDetails.townCity : "",
      zipCode: personalDetails ? personalDetails.zipCode : "",
      countryCode: "+1",
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmitStep1)} className="h-full grow shrink-0 overflow-scroll scroll-hide mt-0">

      <div className="mb-2 overflow-hidden">
        <GvInputController
          control={control}
          name="firstName"
          label="First name"
          placeholder="First Name"
          className="font-semibold"
        />
        <GvInputController
          control={control}
          name="lastName"
          label="Last name"
          placeholder="Last Name"
          className="font-semibold"
        />
      </div>

      <div className="sticky bottom-0 z-[1000] bg-[#F9F6F4] ">
        <GvPrimaryButton type="submit" className="!font-bold" >
          Continue
        </GvPrimaryButton>
      </div>
    </form>
  );
};

export default AddPersonalDetailsForm;
